import { t } from "ttag";

export const GranularControlsExplanation = () => (
  <>
    &nbsp;
    {t`You can set up one caching policy for all your databases, or set up caching policies specific to each database.`}
  </>
);
